import { EntityStatusBadgeVariant } from '@frontend/common';
import { EntityStatusBadge } from '@frontend/components/badge';
import { SpotStatus } from '@frontend/spot/types';
import React from 'react';

const formatSpotStatus = (status: SpotStatus): string => (status.charAt(0).toUpperCase() + status.slice(1)).replace(/_/g, ' ');

const getVariant = (status: SpotStatus): EntityStatusBadgeVariant => {
    switch (status) {
        case SpotStatus.AVAILABLE:
            return EntityStatusBadgeVariant.Completed;
        case SpotStatus.DISABLED:
        default:
            return EntityStatusBadgeVariant.Cancelled;
    }
};

export interface SpotStatusBadgeProps {
    status: SpotStatus;
}

export const SpotStatusBadge = ({ status }: SpotStatusBadgeProps) => (
    <EntityStatusBadge
        label={formatSpotStatus(status)}
        variant={getVariant(status)}
    />
);
